import { render, staticRenderFns } from "./produtosPregao.vue?vue&type=template&id=052631d4"
import script from "./produtosPregao.vue?vue&type=script&lang=js"
export * from "./produtosPregao.vue?vue&type=script&lang=js"
import style0 from "./produtosPregao.vue?vue&type=style&index=0&id=052631d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports